module.exports = __webpack_public_path__ + "img/famifsi.9d89e264.jpg";